import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
export const boughtPlansList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/business/@me/subscriptions", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const checkOfferCode = async ({ code, planId, accessToken }) => {
  try {
    const res = await axiosInstance.get("/business/plans/offerCode", {
      params: { code, planId },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      if (status == 404) {
        console.warn(
          "خطای 404:.کد تخفیف وارد شده نا معتبر می باشد."
        );
       toast.error("کد تخفیف وارد شده نامعتبر می باشد.")
      }
      if (status == 409) {
        console.warn(
          "خطای 409:.کد تخفیف وارد شده منقضی شده است   ."
        );
        if(serverError=="OfferCode is unavailable at the moment."){
          toast.error("در حال حاضر امکان استفاده از کد تخفیف واردشده،وجود ندارد.لطفا بعدا تلاش کنید.")
        }else if(serverError=="OfferCode is expired by date."){
          toast.error("کد تخفیف وارد شده منقضی شده است.")
        }else if(serverError=="OfferCode is expired."){
          toast.error("کد تخفیف وارد شده استفاده شده است.")
        }
      
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطا در دریافت اطلاعات کد تخفیف ",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
